<template>
  <!-- 自动发货管理 -->
  <div class="automatic_delivery-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-switch
            v-model="manualDelivery"
            :active-value="true"
            :inactive-value="false"
            active-text="开启自动发货"
            inactive-text="关闭自动发货"
            @change="handleManualDelivery"
          >
          </el-switch>
        </el-form-item>
      </el-form>

      <el-divider></el-divider>
      <h3>自动发货风控：</h3>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="单用户当日最大发货值：">
          <el-input v-model="riskControlData.extract"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveRiskControl">保存</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>

      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="query.user_id" placeholder="用户id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)" :loading="buttonLoading"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-input v-model="formData.uid" placeholder="用户id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addUser" :loading="buttonLoading"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <p class="prompt">发货白名单：</p>
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="user_id" label="用户Uid"></el-table-column>
        <el-table-column label="用户名称">
          <template slot-scope="{ row }">
            {{ row.user && row.user.name }}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="添加时间"></el-table-column>
        <el-table-column label="操作" width="350px">
          <template slot-scope="{ row }">
            <el-row>
              <el-button type="danger" @click="handleDelete(row)"
                >移除
              </el-button>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { postData, patchData, server, getApiData, patchApiData, postApiData, delApiData } from '@/http'

export default {
  name: 'automatic_delivery',
  components: {
  },
  data() {
    return {
      loading: false,//页面数据加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//页面查询条件
        page: 1,
        user_id: ""
      },
      dataList: undefined,//数据列表
      manualDelivery: false,//自动发货开关状态，默认是关
      formData: {
        uid: undefined
      },
      riskControlData: {
        extract: '',
      },
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    ...mapState({
      boxCategories: (state) => state.data.boxCategories,//盒子分类数据
    })
  },
  watch: {
  },
  created() {
    this.getData()
    this.getManualDelivery()//获取发货开关状态
    this.getRiskControl()//获取风控数据
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['getBoxCategories']),
    handleManualDelivery() {
      //关闭/开启自动发货
      let params = { manualDelivery: this.manualDelivery }
      patchApiData('manual_delivery', params).then(res => {
        this.$message.success("操作成功！")
        this.manualDelivery = res.data
      })
        .catch((err) => {
          this.manualDelivery = !this.manualDelivery
        })
    },
    getManualDelivery() {
      //获取关闭/开启自动发货按钮状态
      getApiData('manual_delivery')
        .then(res => {
          this.manualDelivery = res.data
        })
        .finally(() => {
        })
    },
    getData(num) {
      //获取列表数据
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('user_dont_automatic', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    addUser() {
      //添加用户进白名单
      this.buttonLoading = true
      let params = {
        user_id: this.formData.uid
      }
      postApiData('user_dont_automatic', params).then(res => {
        if (res) {
          this.$message.success('添加成功！')
          this.getData()
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    handleDelete(rowInfo) {
      //移除用户
      this.$confirm('确定要移除吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          user_id: rowInfo.user.id
        }
        delApiData(`user_dont_automatic`, params).then(res => {
          this.$message.success('移除成功！')
          this.getData()
        })
      }).catch(() => { })
    },
    getRiskControl() {
      //获取风险控制数据
      getApiData('risk_control')
        .then(res => {
          this.riskControlData = res
        })
        .finally(() => {
        })
    },
    saveRiskControl() {
      //保存风险控制
      let params = this.riskControlData
      patchApiData('risk_control', params)
        .then(res => {
          this.$message.success("保存成功！")
          this.getRiskControl()//刷新数据
        })
        .finally(() => {
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  },
}
</script>

<style lang="less" scoped>
.automatic_delivery-box {
  header {
  }

  .body-box {
    .prompt {
      font-size: 16px;
      font-weight: 600;
      color: #666;
    }
  }
}
</style>